import SearchResultHeadline from './SearchResultHeadline';

export default SearchResultHeadline;
